export const SIMILARWEB_EXTENSION_ID = "hoklmmgfnpapgjgcpechhaamimifchmp";

const SIMILARWEB_EXTENSION_RESOURCE = "panel/panel.html";

const detectChromeExtension = async (extensionId: string, resourcePath: string): Promise<boolean> => {
    if (typeof fetch === "undefined") {
        return false;
    }

    try {
        const response = await fetch(`chrome-extension://${extensionId}/${resourcePath}`);
        return response.ok;
    } catch {
        return false;
    }
};

export const isSimilarwebExtensionInstalled = (): Promise<boolean> =>
    detectChromeExtension(SIMILARWEB_EXTENSION_ID, SIMILARWEB_EXTENSION_RESOURCE);
